"use client";
import React from 'react';
import Lottie, { LottieProps } from "react-lottie-player";


export default function LottiePlayer(props: LottieProps) {
  return (
    <Lottie {...props} />
  )
}
